const callbacks: Array<() => void> = [];

export const registerGlobalReset = (cb: () => void) => callbacks.push(cb);

export const runGlobalResets = () => callbacks.forEach((cb) => cb());
